/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class MainGuardService {
  private isBrowser: boolean;
  platformId = inject(PLATFORM_ID);
  router = inject(Router);
  authService = inject(AuthService);
  encryptionService = inject(EncryptionService);

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    if (!this.authService.isAuthenticated()) {
      return true;
    }

    const profile = this.encryptionService.decryptLocalStorage('profile');

    if (profile?.type === 'DRIVER') {
      return this.router.parseUrl('/sp/my-trips');
    }

    return this.router.parseUrl('/sp-profile/profile');
  }
}

export const MainGuard = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(MainGuardService).canActivate(next, state);
};
